import React from 'react';
import { toast } from 'sonner';
import { Copy } from 'lucide-react';
const InternalColors: React.FC = () => {
  const copyToClipboard = async (text: string, label: string) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(`Copied ${label} to clipboard`);
    } catch (err) {
      toast.error('Failed to copy');
    }
  };
  const gradientStops = [{
    position: '0%',
    hex: '#BFFFA2',
    label: 'Start'
  }, {
    position: '27%',
    hex: '#7CD27F',
    label: '27%'
  }, {
    position: '79%',
    hex: '#ABCBE0',
    label: '79%'
  }, {
    position: '89%',
    hex: '#CBABCE',
    label: '89%'
  }, {
    position: '97%',
    hex: '#A390CB',
    label: 'End'
  }];
  return <div className="mb-12 space-y-8" data-id="element-74">
      <div data-id="element-75">
        <h2 className="text-xl font-semibold text-slate-800 mb-3" data-id="element-76">
          Internal Color Usage
        </h2>
        <div className="bg-white p-4 rounded-lg shadow-sm" data-id="element-77">
          <div className="flex items-center gap-3" data-id="element-78">
            <div className="w-12 h-12 rounded-md bg-[#001617]" data-id="element-79" />
            <div className="flex-1" data-id="element-80">
              <div className="flex items-center gap-2" data-id="element-81">
                <p className="font-medium text-slate-900" data-id="element-82">Deep Matrix</p>
                <div className="flex items-center gap-1.5" data-id="element-83">
                  <code className="px-2 py-1 bg-slate-100 rounded text-sm font-mono" data-id="element-84">
                    #001617
                  </code>
                  <button onClick={() => copyToClipboard('#001617', '#001617')} className="p-1 text-slate-500 hover:text-slate-900 transition-colors" title="Copy color code" data-id="element-85">
                    <Copy size={14} data-id="element-86" />
                  </button>
                </div>
              </div>
              <p className="text-sm text-slate-500 mt-0.5" data-id="element-87">(primary)</p>
            </div>
          </div>
        </div>
      </div>

      <div data-id="element-88">
        <h2 className="text-xl font-semibold text-slate-800 mb-3" data-id="element-89">
          Brand Gradient
        </h2>
        <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-90">
          <div className="w-full h-24 rounded-lg mb-4" style={{
          background: 'linear-gradient(90deg, #BFFFA2 0%, #7CD27F 27%, #ABCBE0 79%, #CBABCE 89%, #A390CB 97%)'
        }} data-id="element-91" />
          <div className="space-y-3" data-id="element-92">
            {gradientStops.map((stop, index) => <div key={index} className="flex items-center gap-3" data-id="element-93">
                <div className="w-10 h-10 rounded-md border border-slate-200" style={{
              backgroundColor: stop.hex
            }} data-id="element-94" />
                <div className="flex-1 flex items-center gap-2" data-id="element-95">
                  <span className="text-sm text-slate-600 w-12" data-id="element-96">
                    {stop.position}
                  </span>
                  <code className="px-2 py-1 bg-slate-100 rounded text-sm font-mono" data-id="element-97">
                    {stop.hex}
                  </code>
                  <button onClick={() => copyToClipboard(stop.hex, stop.hex)} className="p-1 text-slate-500 hover:text-slate-900 transition-colors" title="Copy color code" data-id="element-98">
                    <Copy size={14} data-id="element-99" />
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default InternalColors;